import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { PersonNameService } from '../../../../../security/services/person-name.service';
import { SharedToasterService } from '../../../../../shared/services/shared-toaster.service';
import { AssignmentParticipantSkillStateEnum } from '../../models/assignment-participants-attendances/enums/assignment-participant-skill-state.enum';
import { AssignmentParticipantSkillUpdateModel } from '../../models/assignment-participants/assignment-participant-skill-update.model';
import { AssignmentParticipantSkillModel } from '../../models/assignment-participants/assignment-participant-skill.model';
import { AssignmentParticipantSkillsUpdateModel } from '../../models/assignment-participants/assignment-participant-skills-update.model';
import { AssignmentParticipantSkillsModel } from '../../models/assignment-participants/assignment-participant-skills.model';
import { AssignmentParticipantSkillsService } from '../../services/assignment-participant-skills.service';

@Component({
    templateUrl: './assignment-participant-skills-modal.component.html',
    styleUrl: './assignment-participant-skills-modal.component.scss'
})
export class AssignmentParticipantSkillsModalComponent implements OnInit {
    @Input({ required: true }) assignmentId!: number;

    protected skillsUpdates: AssignmentParticipantSkillsUpdateModel[] = [];

    protected isConfirming: boolean = false;
    protected nextTextKey: string = 'modal.nextButton';
    protected confirmTextKey: string = 'modal.confirmButton';

    protected skills: AssignmentParticipantSkillModel[] | null = null;
    protected participantsSkills: AssignmentParticipantSkillsModel[] | null = null;
    protected isLoading: boolean = false;

    protected assignmentParticipantSkillStateEnum = AssignmentParticipantSkillStateEnum;

    constructor(
        private bsModalRef: BsModalRef,
        private sharedToasterService: SharedToasterService,
        private assignmentParticipantSkillsService: AssignmentParticipantSkillsService,
        protected personNameService: PersonNameService
    ) { }

    ngOnInit(): void {
        this.loadParticipantSkills();
    }

    next(): void {
        if (this.isConfirming) {
            this.updateParticipantSkills();
        } else {
            this.isConfirming = true;
        }
    }

    back(): void {
        this.isConfirming = false;
    }

    protected changeState(event: Event, assignmentParticipantSkills: AssignmentParticipantSkillsModel, participantSkill: AssignmentParticipantSkillModel, newState: AssignmentParticipantSkillStateEnum): void {
        // this is needed to prevent default focus behavior
        event.preventDefault();

        participantSkill.state = newState;

        var skillUpdate = this.skillsUpdates.find(x => x.personId == assignmentParticipantSkills.personId);
        if (skillUpdate == undefined && participantSkill.originState == newState) return;

        if (skillUpdate == null) {
            skillUpdate = this.getAssignmentParticipantSkillsUpdateModel(assignmentParticipantSkills);
            this.skillsUpdates.push(skillUpdate);
        }

        // remove item from added list if was added before
        if (skillUpdate.addedSkills.find(x => x.skillId == participantSkill.skillId)) {
            skillUpdate.addedSkills.splice(skillUpdate.addedSkills.findIndex(x => x.skillId == participantSkill.skillId), 1);
        }

        // remove item from removed list if was added before
        if (skillUpdate.removedSkills.find(x => x.skillId == participantSkill.skillId)) {
            skillUpdate.removedSkills.splice(skillUpdate.removedSkills.findIndex(x => x.skillId == participantSkill.skillId), 1);
        }

        // remove item from extending list if was added before
        if (skillUpdate.extendingSkills.find(x => x.skillId == participantSkill.skillId)) {
            skillUpdate.extendingSkills.splice(skillUpdate.extendingSkills.findIndex(x => x.skillId == participantSkill.skillId), 1);
        }

        // return if participant did not had skill before
        if (participantSkill.originState == newState) return;

        switch (newState) {
            case AssignmentParticipantSkillStateEnum.Lacking:
                // add item to removed list if not  added before
                if (!skillUpdate.removedSkills.find(x => x.skillId == participantSkill.skillId)) {
                    let newSkillUpdate = this.getAssignmentParticipantSkillUpdateModel(participantSkill);
                    skillUpdate.removedSkills.push(newSkillUpdate)
                }
                break;

            case AssignmentParticipantSkillStateEnum.InPossession:
                // add item to added list if not  added before
                if (!skillUpdate.addedSkills.find(x => x.skillId == participantSkill.skillId)) {
                    let newSkillUpdate = this.getAssignmentParticipantSkillUpdateModel(participantSkill);
                    skillUpdate.addedSkills.push(newSkillUpdate)
                }
                break;
            case AssignmentParticipantSkillStateEnum.Extending:
                // add item to added list if not  added before
                if (!skillUpdate.extendingSkills.find(x => x.skillId == participantSkill.skillId)) {
                    let newSkillUpdate = this.getAssignmentParticipantSkillUpdateModel(participantSkill);
                    skillUpdate.extendingSkills.push(newSkillUpdate)
                }
                break;
        }


    }

    protected isAnySkillUpdated(): boolean {
        if (!this.skillsUpdates.length) return false
        if (this.skillsUpdates.filter(x => x.addedSkills.length).length) return true;
        if (this.skillsUpdates.filter(x => x.removedSkills.length).length) return true;
        if (this.skillsUpdates.filter(x => x.extendingSkills.length).length) return true;

        return false;
    }

    protected getSortedSkills(skills: AssignmentParticipantSkillUpdateModel[]): AssignmentParticipantSkillUpdateModel[] {
        return skills.sort((a, b) => {
            if (a.skillSort == null) return 1;
            if (b.skillSort == null) return -1;
            return a.skillSort - b.skillSort
        });
    }

    protected getSortedSkillsUpdates(skillsUpdates: AssignmentParticipantSkillsUpdateModel[]): AssignmentParticipantSkillsUpdateModel[] {
        return skillsUpdates.sort((a, b) => (a.personFirstName + a.personLastName).localeCompare((b.personFirstName + b.personLastName)));
    }

    protected isSelectedAndNew(model: AssignmentParticipantSkillModel): boolean {
        if (model.state == AssignmentParticipantSkillStateEnum.InPossession && model.originState != AssignmentParticipantSkillStateEnum.InPossession) return true;
        return false;
    }

    protected isSelectedAndExisting(model: AssignmentParticipantSkillModel): boolean {
        if (model.state == AssignmentParticipantSkillStateEnum.InPossession && model.originState == AssignmentParticipantSkillStateEnum.InPossession) return true;
        return false;
    }

    protected isLackingAndNotExisting(model: AssignmentParticipantSkillModel): boolean {
        if (model.state == AssignmentParticipantSkillStateEnum.Lacking && model.originState != AssignmentParticipantSkillStateEnum.InPossession) return true;
        return false;
    }

    protected isLackingAndExisting(model: AssignmentParticipantSkillModel): boolean {
        if (model.state == AssignmentParticipantSkillStateEnum.Lacking && model.originState == AssignmentParticipantSkillStateEnum.InPossession) return true;
        return false;
    }

    protected isExtendingdExisting(model: AssignmentParticipantSkillModel): boolean {
        if (model.state == AssignmentParticipantSkillStateEnum.Extending && model.originState == AssignmentParticipantSkillStateEnum.InPossession) return true;
        return false;
    }

    private getAssignmentParticipantSkillsUpdateModel(assignmentParticipantSkills: AssignmentParticipantSkillsModel): AssignmentParticipantSkillsUpdateModel {
        let newSkillsUpdate: AssignmentParticipantSkillsUpdateModel = {
            personId: assignmentParticipantSkills.personId,
            personFirstName: assignmentParticipantSkills.personFirstName,
            personLastName: assignmentParticipantSkills.personLastName,
            addedSkills: [],
            removedSkills: [],
            extendingSkills: []
        };

        return newSkillsUpdate;
    }

    private getAssignmentParticipantSkillUpdateModel(participantSkill: AssignmentParticipantSkillModel): AssignmentParticipantSkillUpdateModel {
        let newSkillUpdate: AssignmentParticipantSkillUpdateModel = {
            skillId: participantSkill.skillId,
            sportSkillId: participantSkill.sportSkillId,
            skillName: participantSkill.skillName,
            skillSort: participantSkill.skillSort
        };

        return newSkillUpdate;
    }

    private loadParticipantSkills(): void {
        this.assignmentParticipantSkillsService.getAssignmentParticipantSkill(this.assignmentId).subscribe({
            next: (response) => {
                this.processLoadedParticipantsSkills(response);
            },
            error: (error) => {
                this.sharedToasterService.showGeneralDataLoadingError();
            }
        });
    }

    private updateParticipantSkills(): void {
        this.isLoading = true;
        this.assignmentParticipantSkillsService.updateAssignmentParticipantSkill(this.assignmentId, this.skillsUpdates).subscribe({
            next: () => {
                this.bsModalRef.hide();
            },
            error: (error) => {
                this.sharedToasterService.showGeneralSavingError();
                this.isLoading = false;
            }
        });
    }

    private processLoadedParticipantsSkills(assignmentParticipantSkills: AssignmentParticipantSkillsModel[]): void {
        if (assignmentParticipantSkills == null || !assignmentParticipantSkills.length || assignmentParticipantSkills[0].skills == null || !assignmentParticipantSkills[0].skills.length) {
            this.participantsSkills = [];
            return;
        }

        assignmentParticipantSkills.forEach(x => {
            x.skills = x.skills.sort((a, b) => {
                if (a.skillSort == null) return 1;
                if (b.skillSort == null) return -1;
                return a.skillSort - b.skillSort
            }
            );

            // sets to selected if allready has skill
            x.skills.forEach(s => {
                s.originState = s.state;
            });
        });

        // sort by names
        assignmentParticipantSkills = assignmentParticipantSkills.sort((a, b) => (a.personFirstName + a.personLastName).localeCompare((b.personFirstName + b.personLastName)));

        // assign data

        this.skills = assignmentParticipantSkills[0].skills;
        this.participantsSkills = assignmentParticipantSkills;
    }
}
